import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import basicLayout from '../layouts/basicLayout'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/user/login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/user/register.vue'),
  },
  {
    path: '/find-password',
    name: 'find-password',
    component: () => import('../views/user/find-password.vue'),
  },
  {
    path: '/basic',
    component: basicLayout,
    children: [
      {
        path: '/home',
        name: 'basic-home',
        meta: {},
        component: () => import('../views/home/index.vue')
      },
      {
        path: '/enterDw',//入驻云仓 
        name: 'enterDw',
        meta: {},
        component: () => import('../views/auth/enterDw.vue')
      },
      {
        path: '/auth',
        name: 'basic-auth',
        meta: {},
        component: () => import('../views/auth/index.vue')
      },
      {
        path: '/user-center',
        name: 'basic-center',
        meta: {},
        component: () => import('../views/user/index.vue')
      },
      {
        path: '/address-list',
        name: 'basic-address',
        meta: {},
        component: () => import('../views/address/list.vue')
      },
      {
        path: '/list-take-order',
        name: 'basic-list-take-order',
        meta: {},
        component: () => import('../views/take-order/list-take-order.vue')
      },
      {
        path: '/list-push-me',
        name: 'basic-list-push-me',
        meta: {},
        component: () => import('../views/take-order/list-push-me.vue')
      },
      {
        path: '/detail-take-order',
        name: 'basic-detail-take-order',
        meta: {},
        component: () => import('../views/take-order/detail.vue')
      },
      {
        path: '/take-order-pay',
        name: 'basic-take-order-pay',
        meta: {},
        component: () => import('../views/take-order/take-order-pay.vue')
      },
      {
        path: '/addCmt',
        name: 'addCmt',
        meta: {
        },
        component: () => import('../views/order/add-cmt.vue')
      },
      {
        path: '/addOem',
        name: 'addOem',
        meta: {
        },
        component: () => import('../views/order/add-oem.vue')
      },
      {
        path: '/editCmt',
        name: 'editCmt',
        meta: {
        },
        component: () => import('../views/order/edit-cmt.vue')
      },
      {
        path: '/editOem',
        name: 'editOem',
        meta: {
        },
        component: () => import('../views/order/edit-oem.vue')
      },
      {
        path: '/order',//销售商,发单后的列表
        name: 'orderList',
        meta: {
        },
        component: () => import('../views/order/list.vue')
      },
      {
        path: '/orderDetail',//销售商,发单后的列表
        name: 'orderDetail',
        meta: {
        },
        component: () => import('../views/order/detail.vue')
      },
      {
        path: '/orderProgress',//进度时间轴和各种操作
        name: 'orderProgress',
        meta: {
        },
        component: () => import('../views/order/progress.vue')
      },
      {
        path: '/fabric',//面料列表
        name: 'fabricList',
        meta: {
        },
        component: () => import('../views/fabric/list.vue')
      },
      {
        path: '/flowerDetail',//面料列表
        name: 'flowerDetail',
        meta: {
        },
        component: () => import('../views/fabric/detail-flower.vue')
      },
      {
        path: '/fabricDetail',//面料列表
        name: 'fabricDetail',
        meta: {
        },
        component: () => import('../views/fabric/detail-fabric.vue')
      }
    ]
  }
 
]

const router = new VueRouter({
  routes
})

export default router
